import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokArticlePage } from "@/storyblok";

import { type BlokProps, StoryblokComponentList } from "@frend-digital/storyblok";
import styles from "./ArticlePageBlok.module.css";
import { PathBreadcrumbs } from "@/components/ui/PageBreadcrumbs";
import type { BaseSBType } from "@/types/storyblok-compat";
import { SegmentControl } from "@/components/SegmentControl";

export const ArticlePageBlok = ({ blok, preview, ...rest }: BlokProps<BlokArticlePage>) => {
	return (
		<SegmentControl segments={blok}>
			<BlokWrap asChild editable={blok} className={styles.root}>
				<main>
					<PathBreadcrumbs title={blok.listingTitle} className={styles.articleBreadcrumbs} />
					{blok.header && (
						<StoryblokComponentList data-header bloks={blok.header} preview={preview} {...rest} />
					)}

					{!!blok.body && (
						<StoryblokComponentList bloks={blok.body as BaseSBType[]} preview={preview} {...rest} />
					)}
				</main>
			</BlokWrap>
		</SegmentControl>
	);
};
